export default __webpack_public_path__ + "static/media/worker8.a0de35ab.jpeg";